import React from "react";

import styled from "styled-components/macro";

import { useSignups } from "Signups/state";
import {
  useBackgroundColor,
  useHasDescriptionOrMedia,
} from "Signups/stateHooks";
import { AnimatePresence, motion } from "framer-motion";

import { EditorTypography } from "UI/FnrTextEditor/EditorTypography";
import { wrapLongWords } from "UI/styles";

import ImageVideo from "./SignupHeader/ImageVideo";
import { animate, initial } from "./SignupHeader/animation";

export default function InfoColumn() {
  const [state] = useSignups();
  const { description } = state.currentSignupList;
  const { colorVariant } = useBackgroundColor();
  const { hasTwoColumns } = useHasDescriptionOrMedia();

  const hasDescription = description?.trim()?.length > 0;

  if (!hasTwoColumns) return null;

  return (
    <LeftColumnWrapper>
      <ImageVideo />

      <AnimatePresence>
        {hasDescription ? (
          <Description
            data-cy="Signup_PublicDescription"
            initial={initial}
            animate={{
              ...animate,
              transition: { ...animate.transition, delay: 0.2 },
            }}
            $lightMode={colorVariant === "light"}
          >
            <Label>Details</Label>
            <DescriptionContent
              dangerouslySetInnerHTML={{
                __html: description,
              }}
            />
          </Description>
        ) : null}
      </AnimatePresence>
    </LeftColumnWrapper>
  );
}

const LeftColumnWrapper = styled.div`
  margin-bottom: 30px;
  z-index: 1;
`;

const Label = styled.div`
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  opacity: 0.5;
  margin-bottom: 0.5rem;
`;

const Description = styled(motion.div)`
  opacity: 0.75;
  font-size: 16px;
  color: ${({ $lightMode }) => ($lightMode ? "#15436a;" : "white")};
  ${wrapLongWords}
`;

const DescriptionContent = styled(EditorTypography)`
  font-weight: 400;
`;